// ----------------------------------------------------------------------------
// Snippet: Swiper Control
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_swiper-control.scss';
